import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPhotoAlbums, deletePhotoAlbum, type PhotoAlbum } from '../../services/api/photos';

export default function PhotosManagerPage() {
  const { t } = useTranslation();
  const [albums, setAlbums] = useState<PhotoAlbum[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPhotoAlbums()
      .then(setAlbums)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  async function handleDelete(id: string) {
    if (!confirm('Delete this gallery?')) return;
    try {
      await deletePhotoAlbum(id);
      setAlbums((a) => a.filter((x) => x.id !== id));
    } catch (e) {
      console.error(e);
    }
  }

  if (loading) return <p className="text-[var(--color-text-muted)]">{t('common.loading')}</p>;

  return (
    <div className="admin-page">
      <h1 className="admin-page__title">{t('admin.photos')}</h1>

      <section className="admin-create-gallery-card">
        <h2 className="admin-create-gallery-card__title">{t('admin.createNewGallery')}</h2>
        <p className="admin-create-gallery-card__hint">{t('admin.createNewGalleryHint')}</p>
        <Link to="/admin/photos/new" className="admin-btn admin-btn--primary admin-create-gallery-card__btn">
          {t('admin.createNewGallery')}
        </Link>
      </section>

      <section className="admin-galleries-section">
        <h2 className="admin-galleries-section__title">{t('admin.yourGalleries')}</h2>
        {albums.length === 0 ? (
          <p className="admin-page__empty">{t('admin.noGalleries')}</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>{t('admin.titleEn')}</th>
                  <th>{t('admin.slug')}</th>
                  <th style={{ textAlign: 'right' }}>{t('common.edit')} / {t('common.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {albums.map((a) => (
                  <tr key={a.id}>
                    <td>{a.title_en}</td>
                    <td>{a.slug}</td>
                    <td style={{ textAlign: 'right' }}>
                      <Link to={`/admin/photos/albums/${a.id}`}>{t('common.edit')}</Link>
                      <button type="button" onClick={() => handleDelete(a.id)} className="admin-table__danger">{t('common.delete')}</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
